import y2020 from "./2020";
import y2021 from "./2021";
import y2022 from "./2022";
import y2023 from "./2023";
import y2024 from "./2024";
import y2025 from "./2025";

export default [
	...y2020,
	...y2021,
	...y2022,
	...y2023,
	...y2024,
	...y2025
];
